import React, { Fragment } from "react";

import { useIsClientSide } from "@utils/hooks/isClient.hook";
import { formatPrice } from "@utils/productPrice";

import { useGranite } from "@redux/modules/value/translations/translations.provider";

import { ProductLabel } from "@components/Product/Layout/ProductLabel/productLabel.component";

type Props = {
    cashbackAmount?: number | null;
    cashbackUnit?: string | null;
    priceAfterCashbackIsApplied: number | null;
};

const CASHBACK_SELECTOR = "#cashback-modal";

const Discount = ({
    cashbackAmount,
    priceAfterCashbackIsApplied,
    cashbackUnit,
}: Props) => {
    const { t } = useGranite();
    const isClientSide = useIsClientSide();
    const ecommerceLabelHere = t("ecommerce.label.here");
    let cashbackPagePath = CASHBACK_SELECTOR;
    if (isClientSide) {
        const cashBackModal =
            document.querySelector<HTMLDivElement>(CASHBACK_SELECTOR);
        if (cashBackModal && !!cashBackModal.dataset.redirectPath) {
            cashbackPagePath = cashBackModal.dataset.redirectPath;
        }
    }
    const cashbackHelperText = t(
        "ecommerce.label.cashbackInformation",
        `<a href="${cashbackPagePath}">${ecommerceLabelHere}</a>`,
    );

    return (
        <Fragment>
            {cashbackAmount !== null && (
                <React.Fragment>
                    <div className="row mb-2">
                        <ProductLabel
                            text="Cashback"
                            secondary={`${cashbackAmount}${cashbackUnit}`}
                        />
                    </div>
                    <div className="row small">
                        {t(
                            "ecommerce.label.priceAfterCashback",
                            formatPrice(priceAfterCashbackIsApplied, false),
                        )}
                    </div>
                    <div className="row small">
                        <p
                            dangerouslySetInnerHTML={{
                                __html: cashbackHelperText,
                            }}
                        />
                    </div>
                </React.Fragment>
            )}
        </Fragment>
    );
};

export default Discount;
